import { HttpInterceptor } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { StorageManagerService } from '../storage-manager.service';
import { RemoteConfigService } from '../remote-config.service';
import { AccountService } from '../account.service';
import { catchError, switchMap, take } from 'rxjs/operators';
import { from, throwError } from 'rxjs';
import { UiService } from '../ui.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

    recaptchaEndpoints = [
        'v2/smartlogin'
    ];

    constructor(private injector: Injector) {
    }

    intercept(req, next) {

        const headers = { 'x-platform': environment.samsung ? 'lg' : 'samsung' };
        if (req.url.includes('remoteconfig')) {
            return next.handle(req.clone({
                setHeaders: headers
            }));
        }

        let addAuth = false;

        const url = req.url;

        if (this.doAddAuth(url, req)) {
            addAuth = true;
        }

        let config = this.injector.get(RemoteConfigService);

        if (addAuth) {
            let storageManager = this.injector.get(StorageManagerService);
            let ui = this.injector.get(UiService);
            let accessToken;
            if (config.remoteConfig.login_version == 1) {
                accessToken = storageManager.getToken();
            }

            if (config.remoteConfig.login_version == 2) {
                let account = this.injector.get(AccountService);
                return account.updateTokenV2()
                    .pipe(
                        take(1),
                        switchMap(token => {
                            headers['Authorization'] = `bearer ${token}`;
                            let tokenizedReq = req.clone({
                                setHeaders: headers
                            });
                            return next.handle(tokenizedReq);
                        }),
                        catchError(err => {
                            console.log('interceptor', err);
                            if (err && err.status === 401) {
                                account.logoutUser();
                                ui.stopLoading();
                            }
                            return throwError(err);
                        })
                    );
            }

            headers['Authorization'] = `bearer ${accessToken}`;
            let tokenizedReq = req.clone({
                setHeaders: headers
            });
            return next.handle(tokenizedReq);
        }

        if (config.remoteConfig.recaptcha_enabled && this.recaptchaEndpoints.some(x => url.includes(x))) {

            let action = this.getAction(url);
            let account = this.injector.get(AccountService);
            return from(account.getRecaptchaToken(action)).pipe(
                switchMap(recaptchaToken => {
                    headers['x-api-security-token'] = recaptchaToken;
                    return next.handle(req.clone({
                        setHeaders: headers
                    }));
                }));
        }

        return next.handle(req.clone({
            setHeaders: headers
        }));
    }

    private getAction(url: string): string {
        if (url.includes('v2/account/integrity')) {
            return 'integrity';
        }
        if (url.includes('v2/account/login')) {
            return 'login';
        }
        if (url.includes('v2/account/register')) {
            return 'register';
        }
        if (url.includes('v2/account/forgotten-password/send')) {
            return 'forgotten-password';
        }
        return 'API';
    }

    private doAddAuth(url, req): boolean {
        return url.includes('v1/avatar') ||
            url.includes('v1/badges') ||
            url.includes('v1/chat') ||
            url.includes('v1/changePassword') ||
            url.includes('v1/comments') ||
            url.includes('v2/continueWatching') ||
            url.includes('v3/continueWatching') ||
            url.includes('userchannels') ||
            url.includes('v1/displayName') ||
            url.includes('v1/emailPreferences') ||
            url.includes('v1/legaldocuments') ||
            url.includes('v1/key') ||
            url.includes('v1/notification') ||
            url.includes('v2/notification') ||
            url.includes('v2/pushNotification') ||
            url.includes('v2/pushnotification') ||
            url.includes('v1/rateMedia') ||
            url.includes('v1/recommendations') ||
            url.includes('v2/recommendations') ||
            url.includes('v3/recommendations') ||
            url.includes('v1/payPalSubscription') ||
            url.includes('v2/payPalSubscription') ||
            url.includes('v1/purchaseHistory') ||
            url.includes('v1/stripePurchase') ||
            url.includes('v1/videoReport') ||
            url.includes('v1/patreon') ||
            url.includes('v1/points') ||
            url.includes('v1/email') ||
            url.includes('v2/playlist') ||
            url.includes('v3/playlist') ||
            url.includes('ugw') ||
            url.includes('v1/promocode') ||
            url.includes('v1/subscription') ||
            url.includes('v2/subscription') ||
            url.includes('v3/subscription') ||
            url.includes('v4/subscription') ||
            url.includes('v5/subscription') ||
            url.includes('v1/stripe') ||
            url.includes('v1/user') ||
            url.includes('v1/smartlogin') ||
            url.includes('v1/userdevice') ||
            url.includes('v1/voucher') ||
            url.includes('v1/watchHistory') ||
            url.includes('v1/smush') ||
            url.includes('v5/video') ||
            (url.includes('v2/projects') && req.method == 'POST') ||
            (url.includes('v3/projects') && req.method == 'POST') ||
            url.includes('v2/subtitleoptions') ||
            url.includes('/v5/hero/auth') ||
            url.includes('/special') ||
            url.includes('/recommend') ||
            url.includes('/v2/device') ||
            url.includes('/v2/creatorteam/my-follows') ||
            url.includes('/unfollow') ||
            url.includes('/follow') ||
            url.includes('/hero/auth');
    }
}
